import { riwLog } from 'src/hooks/riw-logs';
import authAxios from 'src/utils/authAxios';

export type CompanyLogoSignedUrl = {
  signedUrl: string;
  expiresAt: string;
};

export const getCompanyLogoSignedUrl = async (
  companyId: string
): Promise<CompanyLogoSignedUrl | null> => {
  if (!companyId) {
    return null;
  }

  try {
    const axiosRequest = await authAxios();
    const response = await axiosRequest.get(`/companies/logo/${companyId}`);
    return response.data as CompanyLogoSignedUrl;
  } catch (err) {
    return null;
  }
};

export const getUserCompany = async (companyId) => {
  let companyResult = null;
  try {
    const axiosRequest = await authAxios();
    companyResult = await axiosRequest.get(
      `${import.meta.env.VITE_BE_APP_URL}/companies/get-company/${companyId}`
    );

    return companyResult.data;
  } catch (err) {
    riwLog(
      'error',
      'Companies.ts',
      `User ID: ${companyId}`,
      'Cannot retrieve company data for current user',
      err
    );
  }
  return companyResult;
};

export const updateCompanyProfile = async (
  companyId: string,
  values: any,
  isFormData = false
) => {
  try {
    const axiosRequest = await authAxios();

    let payload;
    let config = {};

    if (isFormData) {
      // If values is already FormData, use it directly
      payload = values;
      // Let axios infer the correct multipart boundary headers
      config = {};
    } else {
      // Otherwise, wrap in values object as before
      payload = { values };
    }

    const result = await axiosRequest.post(
      `${import.meta.env.VITE_BE_APP_URL}/companies/update-company-profile/${companyId}`,
      payload,
      config
    );
    return result.data;
  } catch (err) {
    const message =
      // Prefer backend-provided message when available
      (err as any)?.response?.data?.message ||
      (err as Error)?.message ||
      `Couldn't Update the Company Profile`;
    throw message;
  }
};

// make a call to the backend to delete user and company
export const deleteCompanyAndUsers = async (companyId: string) => {
  try {
    const axiosReq = await authAxios();
    const result = await axiosReq.post(
      `${import.meta.env.VITE_BE_APP_URL}/companies/delete-company-and-users/${companyId}`
    );
    return result.data;
  } catch (err) {
    throw err.response.data.message
      ? err.response.data.message
      : `Couldn't delete your user profile`;
  }
};
